export class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove()
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded')
          }

          const container = this.querySelector('#RecommendationsProduct')
          if (!container) return

          // Swiper is now loaded directly, no need for async loading
          if (!window.Swiper || !window.SwiperNavigation) {
            console.warn('Swiper not available')
            return
          }

          const Swiper = window.Swiper
          const SwiperNavigation = window.SwiperNavigation

          const swiper = new Swiper(container, {
            modules: [SwiperNavigation],
            slidesPerView: 4,
            spaceBetween: 16,
            loop: true,
            navigation: {
              nextEl: this.querySelector('#next-btn'),
              prevEl: this.querySelector('#prev-btn'),
            },
            breakpoints: {
              150: {
                slidesPerView: 2.3,
                spaceBetween: 8,
              },
              500: {
                slidesPerView: 3,
                spaceBetween: 8,
              },
              768: {
                slidesPerView: 4.3,
                spaceBetween: 8,
              },
              968: {
                slidesPerView: 5.3,
                spaceBetween: 8,
              },
            },
          })
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this)
  }
}
